import React from 'react'
import Icon from './Icon'
import {getJson, postJson, resolveRoute} from '../helpers/ajax'
import {getState, lazyProp, linkState, setState, updateState} from "../helpers/react-helpers"
import moment from 'moment'
import ActionButton from "./ActionButton"
import AioDatePicker from "./aio-inputs/AioDatePicker"
import * as kb from '../kb'
import PubSub from 'pubsub-js'
import * as topics from '../pubsub-topics'
import ErrorMessage from './ErrorMessage'
import RDS from 'react-dom/server'
import ButtonRow from './ButtonRow'
import PaymentAllocation from './PaymentAllocation'
import {GridCol, GridRow, GridSection, HtmlGridForm} from './grid-form'
import AioDollar from "./aio-inputs/AioDollar"
import AioSelect from "./aio-inputs/AioSelect"
import AioText from "./aio-inputs/AioText"
import {uuid} from '../util/random'
import {arraySum, mergeIn} from '../util/collections'
import {parseFloat} from '../util/math'

type State = {
    loading: boolean
    saving: boolean
    options: {
        currencies: any[]
        payment_sources: any[]
        total_due: number
        bookings: any[]
    }
    formData: {
        amount: string
        currency: string
        pay_date: string
        source_id: string
        transaction_id: string
        authorization_nbr: string
        alloc: Record<string,number>
    }
};

type Props = {
    bookingId: string|number;
    paymentId?: string;
    formData?: Record<string,any>;
    onCancel?: (...args: any[]) => any;
    afterSave?: (...args: any[]) => any;
};

export default class ManualChargeForm extends React.PureComponent<Props, State> {

    id: string;

    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            saving: false,
            options: {
                currencies: [],
                payment_sources: [],
                total_due: 0,
                bookings: [],
            },
            formData: {
                amount: '888.88',
                currency: '',
                pay_date: moment().format('YYYY-MM-DD'),
                source_id: '',
                transaction_id: '',
                authorization_nbr: '',
                alloc: {},
                ...props.formData,
            }
        };
        this.id = uuid();
        lazyProp.call(this, 'totalAlloc', [(s: any) => s.formData.alloc], (alloc: any) => {
            // console.log(alloc);
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            return (arraySum(Object.values(alloc).map(v => Math.round(parseFloat(v, 0) * 100))) / 100).toFixed(2);
        });
        lazyProp.call(this, 'allocDiff', ['totalAlloc', (s: any) => s.formData.amount], (alloc: any, amount: any) => {
            return (amount - alloc).toFixed(2);
        })
    }

    refresh = () => {
        this.setState({loading: true});

        return getJson(resolveRoute('api.manualPaymentInfo'), {
            bookingId: this.props.bookingId,
            paymentId: this.props.paymentId,
        })
            .then((res: any) => {
                if (res.ok) {
                    // logJson(res.data)
                    updateState.call(this, {
                        options: {$apply: mergeIn(res.data.options)},
                        formData: {$apply: mergeIn(res.data.formData)},
                    });
                }
            })
            .finally(() => {
                this.setState({loading: false});
            });

    };

    componentDidMount = this.refresh;

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if(this.state.formData.amount != prevState.formData.amount && this.state.options.total_due && this.state.options.bookings) {
    //         // alternatively, we can fill the first booking entirely and let the remainder trickle down...
    //         const percents = this.state.options.bookings.map(bk => [bk.id,this.state.options.total_due > 0 ? bk.total_due_value/this.state.options.total_due : 0]);
    //         setState.call(this, 'formData.alloc', fromPairs(percents.map(([id,pc]) => [id,(pc*this.state.formData.amount).toFixed(2)])));
    //     }
    // }

    // payDist = ev => {
    //     const percents = this.state.options.bookings.map(bk => [bk.id,this.state.options.total_due > 0 ? bk.total_due_value/this.state.options.total_due : 0]);
    //     setState.call(this, 'formData.alloc', fromPairs(percents.map(([id,pc]) => [id,(pc*this.state.formData.amount).toFixed(2)])));
    // }
    //
    // payFill = ev => {
    //     let remaining = this.state.formData.amount;
    //     let alloc = {};
    //     for(let bk of this.state.options.bookings) {
    //         let amount = Math.min(remaining, bk.total_due_value);
    //         remaining -= amount;
    //         alloc[bk.id] = amount.toFixed(2);
    //     }
    //     setState.call(this, 'formData.alloc',alloc);
    // }
    //
    // paySplit = ev => {
    //     let amount = this.state.formData.amount/this.state.options.bookings.length;
    //     let alloc = {};
    //     for(let bk of this.state.options.bookings) {
    //         alloc[bk.id] = Math.min(amount,bk.total_due_value).toFixed(2);
    //     }
    //     setState.call(this, 'formData.alloc',alloc);
    // }

    submit = (ev: any) => {
        ev.preventDefault();
        this.setState({saving: true});
        postJson(resolveRoute('bookings.savePayment', {id: this.props.bookingId}), {
            ...this.state.formData,
            id: this.props.paymentId
        })
            .finally(() => {
                this.setState({saving: false});
            })
            .then((res: any) => {
                if (res.ok) {
                    PubSub.publish(topics.PaymentEntered);
                    if (this.props.afterSave) {
                        this.props.afterSave(res.data);
                    } else {
                        kb.notify({
                            text: "Payment recorded",
                            className: 'success',
                        });
                        // console.log('setting state....', this.state.options);
                        this.setState({
                            formData: {
                                amount: '888.88',
                                // currency: this.state.options.default_currency,
                                pay_date: moment().format('YYYY-MM-DD'),
                                source_id: '',
                                transaction_id: '',
                                authorization_nbr: '',
                                alloc: {},
                            }
                        }, () => this.refresh());
                    }
                } else if (res.data.errors) {
                    kb.notify({
                        html: RDS.renderToStaticMarkup(ErrorMessage({errors: res.data.errors})),
                        className: "warning",
                    });
                } else {
                    kb.notify({
                        text: "An unknown error occurred",
                        className: "error",
                    });
                }
            }, (err: any) => {
                kb.notify({
                    html: "A network error occurred. Please try a few more times!",
                    className: "error",
                });
            });
    };

    render() {
        const {options, loading, saving, formData} = this.state;
        const processing: boolean = saving || loading;


        return (
            <HtmlGridForm onSubmit={this.submit} noValidate>
                <GridSection>
                    <GridRow>
                        <GridCol minWidth={100}>
                            <AioDollar label="Amount" id={`${this.id}.amount`} disabled={processing}
                                       loading={processing} {...linkState.call(this, 'formData.amount')} currency={formData.currency}/>
                        </GridCol>
                        <GridCol minWidth={200}>
                            <AioSelect label="Currency" options={options.currencies} placeholder="— Not Selected —" id={`${this.id}.currency`} {...linkState.call(this, 'formData.currency')}
                                       disabled={processing} loading={processing}/>
                        </GridCol>
                    </GridRow>
                    <GridRow>
                        <GridCol minWidth={150}>
                            <AioDatePicker id={`${this.id}.pay_date`} label="Payment Date" {...linkState.call(this, 'formData.pay_date', (date:string)=>date)} />
                        </GridCol>
                        <GridCol minWidth={150}>
                            <AioSelect label="Payment Source" placeholder="— Not Selected —" options={options.payment_sources} id={`${this.id}.source_id`} {...linkState.call(this, 'formData.source_id')}
                                       disabled={processing} loading={processing}/>
                        </GridCol>
                    </GridRow>
                    <GridRow>
                        <GridCol minWidth={250}>
                            <AioText label="Transaction ID"  id={`${this.id}.transaction_id`} {...linkState.call(this, 'formData.transaction_id')}
                                     disabled={processing} loading={processing}/>
                        </GridCol>
                    </GridRow>
                    <GridRow>
                        <GridCol minWidth={250}>
                            <AioText label="Authorization #" id={`${this.id}.authorization_nbr`} {...linkState.call(this, 'formData.authorization_nbr')}
                                     disabled={processing} loading={processing}/>
                        </GridCol>
                    </GridRow>
                    {!this.props.paymentId && this.state.options.bookings && this.state.options.bookings.length > 1 ?
                        <GridRow>
                            <GridCol>
                                <PaymentAllocation
                                    setAlloc={(id, val) => val === undefined ? setState.call(this, 'formData.alloc', id) : setState.call(this, `formData.alloc.${id}`, val)}
                                    getAlloc={id => getState.call(this, `formData.alloc.${id}`)}
                                    chargeAmount={getState.call(this, `formData.amount`)}
                                    bookings={this.state.options.bookings} alloc={this.state.formData.alloc}/>
                            </GridCol>
                        </GridRow> : null}
                </GridSection>

                <ButtonRow>
                    <ButtonRow.Left>
                        <button type="submit" className="btn btn-save" disabled={processing}><Icon
                            name="misc-check"/> {this.props.paymentId ? "Update" : "Record"} Payment
                        </button>
                    </ButtonRow.Left>
                    <ButtonRow.Right>
                        {this.props.onCancel ? <ActionButton className="btn-default" onClick={this.props.onCancel}><Icon
                            name="ion-backspace-outline"/> Cancel</ActionButton> : null}
                    </ButtonRow.Right>
                </ButtonRow>
            </HtmlGridForm>
        )
    }
}
